import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProblemListPage } from '@/features/ProblemList/ProblemListPage';

const searchSchema = z.object({
  tab:        z.enum(['all', 'dsa', 'sql', 'genai']).optional(),
  tag:        z.string().optional(),
  company:    z.string().optional(),
  difficulty: z.string().optional(),
  status:     z.string().optional(),
  q:          z.string().optional(),
  page:       z.number().int().min(1).optional(),
  limit:      z.number().int().min(5).max(100).optional(),
});

export const Route = createFileRoute('/_student/problems/')({
  validateSearch: searchSchema,
  component: ProblemListPage,
});
